import { useTranslation } from '../../core/hooks/useTranslation'
import { Loader2 } from 'lucide-react'

interface SaveButtonProps {
    onClick: () => void
    isLoading?: boolean
    disabled?: boolean
    className?: string
    label?: string
    loadingText?: string
    size?: 'sm' | 'md' | 'lg'
}

export default function SaveButton({
    onClick,
    isLoading = false,
    disabled = false,
    className = '',
    label,
    loadingText,
    size = 'md'
}: SaveButtonProps) {
    const { t } = useTranslation()
    const displayLabel = label || t('save') || 'حفظ'
    const displayLoadingText = loadingText || 'جاري الحفظ...'

    const sizeClasses = {
        sm: 'h-8 py-1 px-3 text-xs',
        md: 'px-10 py-3 text-sm',
        lg: 'px-12 py-3 text-base'
    }

    // If className contains height or padding classes, don't apply size classes
    const hasCustomSize = className.includes('h-') || className.includes('py-') || className.includes('px-')
    const finalSizeClasses = hasCustomSize ? '' : sizeClasses[size]

    return (
        <button
            onClick={onClick}
            disabled={disabled || isLoading}
            className={`bg-[#1E293B] font-semibold text-white hover:bg-[#0F172A] active:bg-[#020617] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center rounded-lg transition-colors ${finalSizeClasses} ${className}`}
        >
            {isLoading ? (
                <>
                    <Loader2 className="w-4 h-4 animate-spin mr-2" />
                    {displayLoadingText}
                </>
            ) : (
                displayLabel
            )}
        </button>
    )
}

